import { useSwiper } from "swiper/react";
import { ArrowRightIcon } from "@heroicons/react/24/solid";

export default function SlideNextButton() {
  const swiper = useSwiper();

  return (
    <button
      id="btnNext"
      onClick={() => swiper.slideNext()}
      className="invisible sm:visible w-10 h-10 text-primary rounded-full bg-secondary top-2/4
                text-center items-center justify-center hover:bg-secondaryHover hover:text-white "
      style={{ "text-align": "-webkit-center" }}
    >
      <ArrowRightIcon className="w-6 h-6" />
    </button>
  );
}
